import { createSelector } from 'reselect'
import getSubscriptionSellingPlansByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-subscription-selling-plans-by-id'
import getIdFromShopifyGraphIdShopifyUtil from 'modules/shopify/utils/get-id-from-gid'

/**
 * @param variantId
 */
const getFirstSubscriptionSellingPlanByIdVariantSelector = variantId => createSelector(
  getSubscriptionSellingPlansByIdVariantSelector(variantId),
  /**
   * @param {SellingPlanDisplayInfo[]} subscriptionSellingPlans
   * @return {number|undefined}
   */
  subscriptionSellingPlans => {
    const id = subscriptionSellingPlans[0]?.id
    if (!id) {
      return
    }

    return getIdFromShopifyGraphIdShopifyUtil(id)
  }
)

export default getFirstSubscriptionSellingPlanByIdVariantSelector
